
import { configureStore } from '@reduxjs/toolkit';
import userSlice from './userSlice';
import studentSlice from './studentSlice';
import commonSlice from './commonSlice';
import mentorSlice from './mentorSlice';
import documentSlice from './documentSlice';
import calendlySlice from './calendlySlice';
import messageSlice from './massageSlice';
import helpSupportSlice from './helpSupportSlice';
import taskSlice from './taskSlice';
import adminSlice from './AdminSlice';
import creditSlice from './creditSlice';

const store = configureStore({
  reducer: {
    userSliceHome: userSlice,
    studentInfoSlice: studentSlice,
    common: commonSlice,
    mentor: mentorSlice,
    document: documentSlice,
    calendly: calendlySlice,
    message: messageSlice,
    helpSupport: helpSupportSlice,
    taskSliceHome: taskSlice,
    admin: adminSlice,
    creditSlice: creditSlice
  }
});

export default store;
